<template>
	<b-card no-body class="p-3" v-loading="is_loading">
		<b-row>
			<b-col cols="12" md="4">
				<p>CCRIS Settlement</p>
				<h3 class="font-weight-600">RM {{ formData.ccris_settlement | moneyFormatter }}</h3>
			</b-col>
			<b-col cols="12" md="4">
				<p>Approval Loan Amount</p>
				<h3 class="font-weight-600">RM {{ formData.loan_amount | moneyFormatter }}</h3>
			</b-col>
			<b-col cols="12" md="4">
				<p>Eligible Loan Limit</p>
				<h3 class="font-weight-600">RM {{ formData.repayment_loan_amount | moneyFormatter }}</h3>
			</b-col>
			<b-col cols="12" md="4">
				<p>Non CCRIS Settlement</p>
				<h3 class="font-weight-600">RM {{ formData.non_ccris_settlement | moneyFormatter }}</h3>
			</b-col>
			<b-col cols="12" md="4">
				<p>Flexi Loan Amount</p>
				<h3 class="font-weight-600"><span v-if="formData.flexi_loan_eligible">RM {{ formData.flexi_loan_amount | moneyFormatter }}</span>
					<span v-if="!formData.flexi_loan_eligible"><i>Not Selected</i></span>
				</h3>
				
			</b-col>
			<b-col cols="12" md="4">
				<p>Other Payment Settlement</p>
				<h3 class="font-weight-600">RM {{ formData.other_payment_settlement | moneyFormatter }}</h3>
			</b-col>
			<b-col cols="12" md="4">
				<p>Moratorium Instalment</p>
				<h3 class="font-weight-600">
					<span v-if="formData.moratorium_eligible">RM {{ formData.moratorium_installment | moneyFormatter
						}}</span>
					<span v-if="!formData.moratorium_eligible"><i>Not Selected</i></span>
				</h3>
			</b-col>
			<b-col v-if="formData.moratorium_eligible" cols="12" md="4">
				<p>Moratorium Eligible</p>
				<h3 class="font-weight-600">
					{{ formData.moratorium_eligible ? (formData ? formData.moratorium_tenure + ' Months' : 0 + 'Months') :
					' - ' }}
				</h3>
			</b-col>
			<!-- <b-col cols="12" md="4">
        <p>Moratorium Instalment</p>
        <h3 class="font-weight-600" :class="getMoratoriumApprovalColor()">
          {{ calculator.moratorium_eligible ? (moratoriumApproval !== '' ? moratoriumApproval : '-') : '-' }}
        </h3>
      </b-col> -->
		</b-row>
	</b-card>
</template>
<script>
import { Switch, Select, Option } from 'element-ui';
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'

export default {
	components: {
		[Switch.name]: Switch,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			formData: {
				flexi_loan_amount: 0,
				flexi_loan_eligible: 0,
				loan_amount: 0,
				repayment_loan_amount: 0,
				final_installment: 0,
				ccris_commitment: 0,
				ccris_settlement: 0,
				non_ccris_settlement: 0,
				other_payment_settlement: 0,
				moratorium_eligible: false,
				moratorium_tenure: 0,
				moratorium_eligible_rate: 0,
				moratorium_installment: 0,
				moratorium_start_period: 1,
			},
		}
	},
	beforeDestroy() {
		this.clearComponent()
	},
	beforeUnmount(){
		this.clearComponent()
	},
	computed: {
		...mapState(useCustomerStore, ['activeFormLoanEc']),
		is_loading() {
			return _gHlp.isLoading('calc_loan_eligible') || _gHlp.isLoading('fetch_loan_ec')
		}
	},
	watch: {
		activeFormLoanEc: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.formData = { ...this.formData, ...newVal }
				}
			},
			immediate: true
		},
	},
	methods: {
		clearComponent(){
			this.formData = {
				flexi_loan_amount: 0,
				flexi_loan_eligible: 0,
				loan_amount: 0,
				repayment_loan_amount: 0,
				final_installment: 0,
				ccris_commitment: 0,
				ccris_settlement: 0,
				non_ccris_settlement: 0,
				other_payment_settlement: 0,
				moratorium_eligible: false,
				moratorium_tenure: 0,
				moratorium_eligible_rate: 0,
				moratorium_installment: 0,
				moratorium_start_period: 1,
			}
		}
	}
}
</script>